import { useState } from "react";
// import { MapEmbed } from "../mapEmbed/MapEmbed";

const CALENDLY_URL = "https://calendly.com/jessicaqtcheng/60min?month=2026-10";
const CALENDLY_CSS = "https://assets.calendly.com/assets/external/widget.css";
const CALENDLY_JS = "https://assets.calendly.com/assets/external/widget.js";

const loadCalendly = () => {
  if (window.Calendly) return Promise.resolve();

  if (!document.querySelector(`link[href="${CALENDLY_CSS}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CALENDLY_CSS;
    document.head.appendChild(link);
  }

  const existing = document.querySelector(`script[src="${CALENDLY_JS}"]`);
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = CALENDLY_JS;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject();
    document.body.appendChild(script);
  });
};

export const ContactUsForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const openCalendly = async (event) => {
    event.preventDefault();
    try {
      await loadCalendly();
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } catch {
      window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailto = `mailto:info@itoinsuranceagency.com?subject=Contact Form Submission&body=Name: ${formData.name}%0D%0APhone: ${formData.phone}%0D%0AEmail: ${formData.email}%0D%0AMessage: ${formData.message}`;
    window.location.href = mailto;
    setSubmitted(true);
  };

  return (
    <div className="contact-page">
      <h1 className="contact-page__title">Contact Us</h1>
      <hr className="section-divider" />
      <div className="contact-page__grid">
        <section className="contact-card contact-card--center">
          <h2>Online Appointments</h2>
          <h3>Inquiries/Quotes</h3>
          <p className="contact-card__meta">30 mins | Free</p>
          <a
            className="contact-page__button"
            href={CALENDLY_URL}
            onClick={openCalendly}
          >
            BOOK
          </a>
        </section>

        <section className="contact-card">
          <h2 className="contact-card__heading--center">Get in Touch!</h2>
          {submitted ? (
            <p className="contact-card__thanks">
              Thank you! Your message has been prepared in your email client.
            </p>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <label className="contact-form__field">
                Name
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </label>
              <label className="contact-form__field">
                Phone*
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone*"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                />
              </label>
              <label className="contact-form__field">
                Email*
                <input
                  type="email"
                  name="email"
                  placeholder="Email*"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </label>
              <label className="contact-form__field">
                Message
                <textarea
                  name="message"
                  placeholder="Tell us the type of consultation you need, and someone will be back to you soon."
                  value={formData.message}
                  onChange={handleChange}
                />
              </label>
              <button className="contact-page__button" type="submit">
                SEND MESSAGE
              </button>
            </form>
          )}
        </section>
      </div>
      <p className="contact-page__note">
        This site is protected by reCAPTCHA and I.T.O. Privacy Policy and Terms
        of Service apply.
      </p>
    </div>
  );
};
